(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-rail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tabs] [role="tab"]');
    if (!tab) return;
    const wrap = tab.closest('[data-tabs]');
    wrap.querySelectorAll('[role="tab"]').forEach((t) => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = !on;
        if (on) panel.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in'));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Shopify's cookie banner exposes window.privacyBanner only where the banner is enabled.
  window.addEventListener('load', () => {
    const btn = document.querySelector('[data-consent-prefs]');
    if (!btn || !window.privacyBanner) return;
    btn.hidden = false;
    btn.addEventListener('click', () => window.privacyBanner.showPreferences());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const plp = document.querySelector('[data-plp]');
    const form = plp && plp.querySelector('[data-bbf]');
    if (!form) return;
    const grid = plp.querySelector('[data-bbf-grid]');
    const items = [...grid.querySelectorAll('[data-item]')];
    const FACETS = ['cinsiyet', 'yas', 'numara', 'kategori', 'marka', 'renk', 'ozellik'];
    const FIELD = { cinsiyet: 'g', yas: 'a', numara: 's', ozellik: 'f' };   // pipe lists
    const PLAIN = { kategori: 't', marka: 'b', renk: 'c' };                 // single values
    const LEGACY = {
      'filter.p.product_type': 'kategori', 'filter.p.vendor': 'marka', 'filter.p.m.custom.filtre_yas': 'yas',
      'filter.v.option.numara': 'numara', 'filter.p.m.custom.filtre_cinsiyet': 'cinsiyet', 'filter.p.m.custom.filtre_ozellik': 'ozellik',
      'filter.p.m.custom.renk_ailesi': 'renk', 'filter.v.availability': 'stok'
    };
    const sortSel = plp.querySelector('[data-bbf-sort]');

    const selected = () => {
      const s = {};
      FACETS.forEach((f) => { s[f] = [...form.querySelectorAll(`input[name="${f}"]:checked`)].map((i) => i.value); });
      s.min = parseFloat(form.min.value) || 0;
      s.max = parseFloat(form.max.value) || Infinity;
      s.stok = form.stok.checked;
      return s;
    };
    const has = (el, facet, v) => FIELD[facet] ? el.dataset[FIELD[facet]].includes(`|${v}|`) : el.dataset[PLAIN[facet]] === v;
    // A product matches when, for every facet with selections, it has at least one of the selected values.
    const matches = (el, s, skip) => FACETS.every((f) => f === skip || !s[f].length || s[f].some((v) => has(el, f, v)))
      && +el.dataset.p >= s.min && +el.dataset.p <= s.max && (!s.stok || el.dataset.av === '1');

    function apply(push = true) {
      const s = selected();
      const hit = items.filter((el) => matches(el, s));
      const order = sortSel.value;
      const key = {
        'fiyat-artan': (a, b) => a.dataset.p - b.dataset.p,
        'fiyat-azalan': (a, b) => b.dataset.p - a.dataset.p,
        'yeni': (a, b) => b.dataset.new - a.dataset.new,
      }[order] || ((a, b) => (b.dataset.av - a.dataset.av) || (a.dataset.i - b.dataset.i));  // buyable first
      hit.sort(key);
      items.forEach((el) => { el.hidden = true; });
      hit.forEach((el) => { el.hidden = false; grid.appendChild(el); el.querySelectorAll('[data-reveal]').forEach((r) => r.classList.add('is-in')); });

      // counts per value, given the other facets' selections
      FACETS.forEach((f) => form.querySelectorAll(`input[name="${f}"]`).forEach((inp) => {
        const n = items.filter((el) => matches(el, s, f) && has(el, f, inp.value)).length;
        const lab = inp.closest('.facet__value, .seg__btn');
        const num = lab && lab.querySelector('[data-n]');
        if (num) num.textContent = n;
        if (lab) lab.classList.toggle('is-disabled', n === 0 && !inp.checked);
        inp.disabled = n === 0 && !inp.checked;
        lab && lab.classList.toggle('is-active', inp.checked);
      }));
      plp.querySelectorAll('[data-quick]').forEach((b) => {
        const inp = form.querySelector(`input[name="${b.dataset.quick}"][value="${CSS.escape(b.dataset.v)}"]`);
        const on = !!(inp && inp.checked);
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
        b.disabled = !!(inp && inp.disabled);
      });

      plp.querySelector('[data-plp-count]').textContent = hit.length;
      plp.querySelector('[data-bbf-apply]').textContent = hit.length;
      plp.querySelector('[data-bbf-empty]').hidden = hit.length > 0;

      // The quick buttons and the filter badge already show what is selected, so the toolbar only offers one reset.
      const active = FACETS.reduce((n, f) => n + s[f].length, 0) + (s.min || s.max !== Infinity ? 1 : 0) + (s.stok ? 1 : 0);
      plp.querySelector('[data-bbf-reset]').hidden = !active;
      const badge = plp.querySelector('[data-bbf-badge]');
      badge.textContent = active; badge.hidden = !active;
      const opt = sortSel.options[sortSel.selectedIndex];
      plp.querySelector('[data-bbf-sort-label]').textContent = opt.dataset.short || opt.text;

      if (push) {
        const p = new URLSearchParams();
        FACETS.forEach((f) => s[f].length && p.set(f, s[f].join(',')));
        if (s.min) p.set('min', s.min);
        if (s.max !== Infinity) p.set('max', s.max);
        if (s.stok) p.set('stok', '1');
        if (order !== 'one-cikan') p.set('sirala', order);
        history.replaceState(null, '', location.pathname + (p.toString() ? `?${p}` : ''));
      }
    }

    function check(f, v, on = true) {
      const inp = form.querySelector(`input[name="${f}"][value="${CSS.escape(v)}"]`);
      if (inp) inp.checked = on;
    }

    // A facet where one value covers every product describes the collection itself (gender on Kız Çocuk, age on Bebek): hide it.
    FACETS.forEach((f) => {
      const inputs = [...form.querySelectorAll(`input[name="${f}"]`)];
      if (inputs.some((inp) => items.every((el) => has(el, f, inp.value)))) {
        const box = form.querySelector(`[data-facet="${f}"]`);
        if (box) box.hidden = true;
        plp.querySelectorAll(`[data-quick="${f}"]`).forEach((b) => { b.hidden = true; });
        plp.querySelectorAll('.plp__quick .plp__gender').forEach((sg) => { if (![...sg.children].some((c) => !c.hidden)) sg.hidden = true; });
      }
    });

    // restore from URL (own params + storefront filter links from menus/search)
    const q = new URLSearchParams(location.search);
    FACETS.forEach((f) => (q.get(f) || '').split(',').filter(Boolean).forEach((v) => check(f, v)));
    for (const [k, v] of q) { if (LEGACY[k] === 'stok') form.stok.checked = true; else if (LEGACY[k]) check(LEGACY[k], v); }
    if (q.get('min')) form.min.value = q.get('min');
    if (q.get('max')) form.max.value = q.get('max');
    if (q.get('stok')) form.stok.checked = true;
    if (q.get('sirala')) sortSel.value = q.get('sirala');

    form.addEventListener('change', () => apply());
    form.addEventListener('input', (e) => { if (e.target.type === 'number') apply(); });
    sortSel.addEventListener('change', () => apply());
    plp.addEventListener('click', (e) => {
      const quick = e.target.closest('[data-quick]');
      if (quick) {
        const f = quick.dataset.quick;
        const inp = form.querySelector(`input[name="${f}"][value="${CSS.escape(quick.dataset.v)}"]`);
        if (!inp) return;
        if (f === 'cinsiyet' && !inp.checked) form.querySelectorAll('input[name="cinsiyet"]').forEach((i) => { i.checked = false; });
        inp.checked = !inp.checked; apply(); return;
      }
      if (e.target.closest('[data-bbf-clear]')) {
        form.reset(); sortSel.value = 'one-cikan'; apply();
      }
    });
    apply(false);
    if ([...q.keys()].some((k) => LEGACY[k])) apply(true);

    const seo = plp.querySelector('[data-seo-text]');
    const seoBtn = plp.querySelector('[data-seo-toggle]');
    if (seo && seoBtn && seo.scrollHeight > seo.clientHeight + 40) {
      seoBtn.hidden = false;
      seoBtn.addEventListener('click', () => {
        const open = seoBtn.getAttribute('aria-expanded') === 'true';
        seoBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        seo.classList.toggle('is-open', !open);
        seoBtn.querySelector('[data-more]').hidden = !open;
        seoBtn.querySelector('[data-less]').hidden = open;
      });
    } else if (seo) { seo.classList.add('is-open'); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (() => {
    const wrap = document.querySelector('[data-related]');
    if (!wrap || !wrap.dataset.url || wrap.dataset.loaded) return;
    wrap.dataset.loaded = '1';
    const io = new IntersectionObserver(async ([en]) => {
      if (!en.isIntersecting) return;
      io.disconnect();
      try {
        const res = await fetch(wrap.dataset.url);
        if (!res.ok) return;
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const track = html.querySelector('[data-related-track]');
        if (track && track.children.length) {
          track.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in'));
          wrap.querySelector('[data-related-track]').replaceWith(track);
        }
      } catch {}
    }, { rootMargin: '400px' });
    io.observe(wrap);
  })();

  } catch(e) { console.error(e); }
})();
})();
